import React from 'react';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Divider from 'material-ui/Divider';
import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import { Select, TextField, withValidatedInputs, Validations } from '../../../../components/forms';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';

import {Done, Close} from 'material-ui-icons';

import Grid from 'material-ui/Grid';

import Files from '../../Files';

import EditationAircraftOffers from './EditationAircraftOffers';
import EditationOfferAvailability from './EditationOfferAvailability';
import EditationFlightRoute from './EditationFlightRoute';

import axios from 'axios';
import tsl from './../../../tsl';

import Immutable from 'immutable';

class Editation extends React.Component {
    state = {
        panelIndex: 0,
        entity: {},
        locations: [],
        offer_statuses: [],
        flight_types: [],
        translations: {},
        activeLanguage: null,
        languages: ['en', 'de', 'fr', 'it'],
    };

    componentWillMount() {
        this.setEntity(this.props.entityData);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.entityData !== newProps.entityData) {
            this.setEntity(newProps.entityData);
        }

        if (this.props.locations || newProps.locations) {
          // if locations were previously set by props, allow setting them to null
          // otherwise only accept non-null prop
          this.setState({
            locations: newProps.locations
          })
        }
    }

    setEntity(entityData) {
        // create deep copy so the cancel button works correctly
        entityData = Immutable.fromJS(entityData).toJS();

        let translations = [];
        for (let i in entityData.translations) {
            const tsl = entityData.translations[i];
            translations[tsl.locale] = tsl;
        }

        this.setState({
            panelIndex: 0,  // show 1st panel
            entity: entityData,
            translations: translations,
            activeLanguage: this.state.languages[0]
        })
    }

    componentDidMount() {
        if (!this.props.locations) {
          axios.get('/api/operator/flight/locations')
            .then((res) => {
              this.setState({locations: res.data.data.sort((a, b) => a.name.localeCompare(b.name))});
            });
        }
        
        axios.get('/api/offer/statuses')
            .then((res) => {
                this.setState({offer_statuses: res.data});
            });
        
        axios.get('/api/flight/types')
            .then((res) => {
                this.setState({'flight_types': res.data});
            });
    }

    togglePanel = (panelIndex) => () => {
        this.setState({
            panelIndex: (panelIndex == this.state.panelIndex) ? null : panelIndex
        })
    };

    closeEditation = () => {
        // reset entity
        this.setEntity(this.props.entityData);

        this.props.closeEditation();
        this.props.resetFormErrors();
    };

    handleChange = event => {
        let entity = this.state.entity;
        entity[event.target.name] = event.target.value;

        this.setState({entity: entity});
    };
    
    handleChangeRelation = event => {
        let prop = event.target.name;

        let entity = this.state.entity;
        entity[prop] = { id: event.target.value };

        this.setState({entity: entity}, () => {
            if (this.state.entity.is_transfer && prop.indexOf('location') >= 0) {
                this.updateTransferRoute();
            }
        });
    };

    handleChangeOffers = newOffers => {
        let newEntity = this.state.entity;

        newEntity.aircraft_offers = newOffers;

        this.setState({
            entity: newEntity
        });
    };

    handleChangeAvailability = newAvailability => {
        let newEntity = this.state.entity;

        newEntity.availability = newAvailability;

        this.setState({
            entity: newEntity
        });
    };

    handleChangeRoute = newRoute => {
        this.setState(state => ({
            entity: {
                ...state.entity,
                route: newRoute
            }
        }));
    };

    handleChangeLanguage = event => {
        this.setState({activeLanguage: event.target.value});
    };

    handleLngChange = event => {
        const prop = event.target.name;
        const actLng = this.state.activeLanguage;
        const value = event.target.value;

        let entityTsls = this.state.translations;
        if (!entityTsls[actLng]) {
            entityTsls[actLng] = {};
        }

        entityTsls[actLng][prop] = value;
        entityTsls[actLng].changed = true;

        this.setState({translations: entityTsls});   
    };

    handleFilesChange = (files) => {
        let entity = this.state.entity;
        entity.files = files;
        this.setState({
            entity: entity
        });
    };

    handleSave = () => {
        if (this.props.trySubmit()) {
            if (!this.state.entity.route || !this.state.entity.route.points || this.state.entity.route.points.length == 0) {
                this.props.addAlert(tsl('offers.edit.no_route'), 'error');
                return;
            }

            if (!this.state.entity.aircraft_offers || this.state.entity.aircraft_offers.length == 0) {
                this.props.addAlert(tsl('offers.edit.no_aircrafts'), 'error');
                return;
            }

            if (!this.state.entity.availability || this.state.entity.availability.length == 0) {
                this.props.addAlert(tsl('offers.edit.no_availability'), 'error');
                return;
            }

            let entity = this.state.entity;

            for (let lngCode in this.state.translations) {
                entity[lngCode] = this.state.translations[lngCode];
            }

            this.props.saveEntity(this.state.entity);

            this.props.resetFormErrors();
        }
    };

    getTotalBlockage = () => {
        const { time_pickup, time_before, time_flight, time_dropoff, time_return, time_after } = this.state.entity;

        // meeting time only creates blockage if time pickup is set (pilot needs to fly to the meeting location)
        const meetingTime = +time_pickup ? +time_pickup + (+time_before || 0) : 0;
        return meetingTime + (+time_flight || 0) + (+time_dropoff || 0) + (+time_return || 0) + (+time_after || 0);
    };

    updateTransferRoute = () => {
        this.setState(state => {
            // we only have location id stored in the entity, need to find the location data
            const pickupLocation = state.entity.location ? state.locations.find(l => l.id === state.entity.location.id) : null;
            const dropoffLocation = state.entity.dropoff_location ? state.locations.find(l => l.id === state.entity.dropoff_location.id) : null;

            const translations = {};

            state.languages.map(lng => {
                const originalTranslations = this.props.entityData.translations ? this.props.entityData.translations.find(t => t.locale === lng) : null;
                // we get generate a default translation, if the translation was not provided in the props and the user has not change it manually (i.e. it was generated by this routine) or it's empty
                const canGenerateTranslation = !state.translations[lng] || state.translations[lng].title === '' || ((!originalTranslations || originalTranslations.title === '') && !state.translations[lng].changed);

                translations[lng] = state.translations[lng];
                if (canGenerateTranslation) {
                    // if one location is missing, remove the generated translation
                    if (!pickupLocation || !dropoffLocation) {
                      translations[lng] = {
                        ...translations[lng],
                        title: ''
                      }
                    } else {
                      translations[lng] = {
                        ...translations[lng],
                        title: tsl('offers.edit.transfer_title', {
                          pickup: pickupLocation.name,
                          dropoff: dropoffLocation.name,
                        }, lng)
                      };
                    }
                }
            });

            if (!pickupLocation || !dropoffLocation) {
              return {
                translations,
                entity: {
                  ...state.entity,
                  route: {
                    ...state.entity.route,
                    points: []
                  }
                }
              };
            }

            return {
                translations,
                entity: {
                  ...state.entity,
                  route: {
                    ...state.entity.route,
                    points: [
                      {
                          gps_lat: pickupLocation.gps_lat,
                          gps_long: pickupLocation.gps_long,
                          position: 1,
                          location_id: pickupLocation.id
                      },
                      {
                          gps_lat: dropoffLocation.gps_lat,
                          gps_long: dropoffLocation.gps_long,
                          position: 2,
                          location_id: dropoffLocation.id
                      }
                    ]
                  }
                }
            };
        });
    };

    renderEntityInformationForm() {

        let current_translation = this.state.translations[this.state.activeLanguage];
        //console.log('tsl', this.state.translations, this.state.activeLanguage);
        if (!current_translation) {
            current_translation = {title: '', description: ''};
        }

        if (!this.state.entity) {
            return null;
        }

        const isTransfer = this.state.entity.is_transfer;

        return (
            <Grid container spacing={24}>
                <Grid item xs={12} sm={6}>
                    
                    <FormControl fullWidth>
                      <InputLabel htmlFor="status">{tsl('offers.edit.status')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="status"
                        value={this.state.entity && this.state.entity.status ? this.state.entity.status.id : 0}
                        onChange={this.handleChangeRelation}
                      >
                        <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                        {this.state.offer_statuses.map((status) => {
                            return (<MenuItem key={status.id} value={status.id}>{status.title}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />

                    <FormControl fullWidth>
                      <InputLabel htmlFor="location">{isTransfer ? tsl('offers.edit.pickup_location') : tsl('offers.edit.location')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="location"
                        value={this.state.entity && this.state.entity.location ? this.state.entity.location.id : 0}
                        onChange={this.handleChangeRelation}
                      >
                        <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                        {this.state.locations.map((loc) => {
                            return (<MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />

                  {
                      isTransfer &&
                        <div>
                            <FormControl fullWidth>
                              <InputLabel htmlFor="dropoff_location">{tsl('offers.edit.dropoff_location')}</InputLabel>
                              <Select
                                formActions={this.props.formActions}
                                required
                                name="dropoff_location"
                                value={this.state.entity && this.state.entity.dropoff_location ? this.state.entity.dropoff_location.id : 0}
                                onChange={this.handleChangeRelation}
                              >
                                <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                                {this.state.locations.map((loc) => {
                                    return (<MenuItem key={loc.id} value={loc.id}>{loc.name}</MenuItem>);
                                })}
                              </Select>
                            </FormControl>
                            <br /><br />
                        </div>
                  }

                    <FormControl fullWidth>
                      <InputLabel htmlFor="flight_type">{tsl('offers.edit.flight_type')}</InputLabel>
                      <Select
                        formActions={this.props.formActions}
                        required
                        name="flight_type"
                        value={this.state.entity && this.state.entity.flight_type ? this.state.entity.flight_type.id : 0}
                        onChange={this.handleChangeRelation}
                        disabled={isTransfer}
                      >
                        <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                        {this.state.flight_types.map((type) => {
                            return (<MenuItem key={type.id} value={type.id}>{type.title}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                    <br /><br />
                </Grid>

                <Grid item xs={12} sm={6} style={{textAlign: 'right'}}>
                    {
                        isTransfer &&
                        <div>
                          <TextField
                            formActions={this.props.formActions}
                            required
                            validations={[
                                Validations.isInteger
                            ]}
                            fullWidth
                            id="time_pickup"
                            label={tsl('offers.edit.time_pickup')}
                            name="time_pickup"
                            value={this.state.entity.time_pickup || ''}
                            onChange={this.handleChange}
                            InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                          />
                          <br /><br />
                        </div>
                    }

                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="time_before"
                        label={tsl('offers.edit.time_before')}
                        name="time_before"
                        value={this.state.entity.time_before || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                    />
                    <br /><br />

                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="time_flight"
                        label={tsl('offers.edit.time_flight')}
                        name="time_flight"
                        value={this.state.entity.time_flight || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                    />
                    <br /><br />

                    {
                        isTransfer &&
                        <div>
                          <TextField
                            formActions={this.props.formActions}
                            required
                            validations={[
                                Validations.isInteger
                            ]}
                            fullWidth
                            id="time_dropoff"
                            label={tsl('offers.edit.time_dropoff')}
                            name="time_dropoff"
                            value={this.state.entity.time_dropoff || ''}
                            onChange={this.handleChange}
                            InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                          />
                          <br /><br />
                          <TextField
                            formActions={this.props.formActions}
                            required
                            validations={[
                                Validations.isInteger
                            ]}
                            fullWidth
                            id="time_return"
                            label={tsl('offers.edit.time_return')}
                            name="time_return"
                            value={this.state.entity.time_return || ''}
                            onChange={this.handleChange}
                            InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                          />
                          <br /><br />
                        </div>
                    }

                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger
                        ]}
                        fullWidth
                        id="time_after"
                        label={tsl('offers.edit.time_after')}
                        helperText={tsl('offers.edit.time_after_helper')}
                        name="time_after"
                        value={this.state.entity.time_after || ''}
                        onChange={this.handleChange}
                        InputProps={{endAdornment: <InputAdornment position="end">min</InputAdornment>}}
                    />
                    <br /><br />

                    <Divider />

                    <br />

                    <TextField
                        fullWidth
                        label={tsl('offers.edit.time_total')}
                        value={this.getTotalBlockage()}
                        disabled
                        InputProps={{
                            endAdornment: <InputAdornment position="end">min</InputAdornment>,
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12}>

                    <FormControl fullWidth>
                        <InputLabel htmlFor="language">{tsl('offers.edit.language_select')}</InputLabel>
                        <Select
                            name="flight_type"
                            value={this.state.activeLanguage ? this.state.activeLanguage : 0}
                            onChange={this.handleChangeLanguage}
                        >
                            <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                            {this.state.languages.map((lang_code) => {
                                return (<MenuItem key={lang_code} value={lang_code}>{lang_code}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                    <br /><br />

                    <TextField
                        formActions={this.props.formActions}
                        required
                        fullWidth
                        id="title"
                        label={tsl('offers.edit.title')}
                        name="title"
                        value={current_translation.title || ''}
                        onChange={this.handleLngChange}
                        InputProps={{startAdornment: 
                            <InputAdornment position="start">{this.state.activeLanguage ? this.state.activeLanguage : ''}</InputAdornment>}}
                    />
                    <br /><br />

                    <TextField
                        fullWidth
                        id="description"
                        label={tsl('offers.edit.description')}
                        name="description"
                        multiline
                        value={current_translation.description || ''}
                        onChange={this.handleLngChange}
                        InputProps={{startAdornment: 
                            <InputAdornment position="start">{this.state.activeLanguage ? this.state.activeLanguage : ''}</InputAdornment>}}
                    />
                    <br /><br />

                </Grid>

            </Grid>
        );
    }

    renderAircraftOffersForm() {
        return (
            <EditationAircraftOffers
                formActions={this.props.formActions}
                offers={this.state.entity.aircraft_offers || []}
                onChange={this.handleChangeOffers}
             />
        );
    }

    routeToString = () => {
        if (this.state.entity.route && this.state.entity.route.points) {
            return this.state.entity.route.points.map(p => `${p.gps_lat},${p.gps_long}` ).join(';');
        }

        return '0';
    };

    render() {
        return (
            <div className="w-100">

                <Button fab raised color="accent"
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.handleSave}
                >
                    <Done />
                </Button>

                <Button fab raised
                    className="jr-fab-btn jr-btn-fab-sm text-white"
                    style={{position: "fixed", bottom: 5, right: 70, zIndex: 9999}}
                    onClick={() => {this.closeEditation()}}
                >
                    <Close />
                </Button>

                <ExpansionPanel expanded={this.state.panelIndex === 0} onChange={this.togglePanel(0)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('offers.edit.information')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        {this.renderEntityInformationForm()}
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel expanded={this.state.panelIndex === 1} onChange={this.togglePanel(1)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('offers.edit.route')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        
                        <EditationFlightRoute
                            key={this.state.entity.is_transfer ? this.routeToString() : this.state.entity.id || 0}
                            editable={!this.state.entity.is_transfer}
                            route={this.state.entity.route}
                            onChange={this.handleChangeRoute}
                            displayed={this.state.panelIndex === 1}  // direct signal just to know when to re-render GoogleMap
                        />

                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel expanded={this.state.panelIndex === 2} onChange={this.togglePanel(2)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('offers.edit.aircrafts_and_prices')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        {this.renderAircraftOffersForm()}

                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel expanded={this.state.panelIndex === 3} onChange={this.togglePanel(3)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('offers.edit.availability')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        
                        <EditationOfferAvailability
                            formActions={this.props.formActions}
                            availability={this.state.entity.availability || []}
                            onChange={this.handleChangeAvailability}
                        />

                    </ExpansionPanelDetails>
                </ExpansionPanel>


                <ExpansionPanel expanded={this.state.panelIndex === 4} onChange={this.togglePanel(4)}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                        <Typography>{tsl('offers.edit.media_and_files')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        <Files 
                            files={this.state.entity ? this.state.entity.files : []} 
                            onChange={this.handleFilesChange} />

                    </ExpansionPanelDetails>
                </ExpansionPanel>

            </div>
        );
    }
}

export default withValidatedInputs(Editation);


// WEBPACK FOOTER //
// ./app/used/offers/routes/Editation.js